export default "__VITE_ASSET__B_zDC58l__"